export default __webpack_public_path__ + "images/medal3.svg";